import React from 'react';
import { ReportData } from '@/types/report';
import { ExecutiveSummary } from './ExecutiveSummary';
import { ResultsOverview } from './ResultsOverview';
import CareerAcceleratorView from './CareerAcceleratorView';
import { SelfAssessmentView } from './SelfAssessmentView';
import LeadershipEdge from './LeadershipEdge';
import { GrowView } from './GrowView';
import { EvaluatorsView } from './EvaluatorsView';
import { CollaboratorGeniusView } from './CollaboratorGeniusView';
import ScrollToTopButton from '../common/FloatingActionButton';

interface ReportContentProps {
  activeTab: string;
  reportData: ReportData;
}

export function ReportContent({ activeTab, reportData }: ReportContentProps) {
  return (
    <div className="border-t border-gray-200">
      <ScrollToTopButton />
      {activeTab === 'career' ? (
        <CareerAcceleratorView />
      ) : activeTab === 'general' ? (
        <>
          <ExecutiveSummary name="Michael" />
          <ResultsOverview />
        </>
      ) : activeTab === 'self-assessment' ? (
        <SelfAssessmentView />
      ) : activeTab === 'leadership' ? (
        <LeadershipEdge />
      ) : activeTab === 'grow' ? (
        <GrowView />
      ) : activeTab === 'evaluators' ? (
        <EvaluatorsView />
      ) : activeTab === 'collaborator' ? (
        <CollaboratorGeniusView />
      ) : (
        null
      )}
    </div>
  );
}